// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"0c816323","602":"0c816323"}[chunkId] + ".chunk.css";
};